import {Buffer} from 'buffer';

export const getBearerToken = (wallet: string, signature: string, mode:string) => `Bearer ${Buffer.from(wallet+':'+signature+':'+mode).toString('base64')}` 